$(document).ready(() => {
	//tabs
	$("body").on("click", ".tabs[data-target] > *:not(.active)", function (e) {
		e.preventDefault();
		const tab_parent = $(this).closest(".tabs"),
			target = tab_parent.attr("data-target");
		if (tab_parent.length > 0 && target) {
			const tab = $(this),
				tabs = tab_parent.find(">*"),
				index = tabs.index(tab);

			$(target).each(function () {
				const content = $(this).find(">*");
				content.removeClass("active");
				content.eq(index).addClass("active");
			});

			tabs.removeClass("active");
			tab.addClass("active");
		}
	});
	$("form.validation").validationEngine({
		showPrompts: false,
		addFailureCssClassToField: "error",
		scroll: false,
		onFieldFailure: function (field) {
			if (field) {
				if (field.is(":radio")) {
					$(field).closest(".radio").addClass("error");
				}
			}
		},
		onFieldSuccess: function (field) {
			if (field) {
				if (field.is(":radio")) {
					$(field).closest(".radio").removeClass("error");
				}
			}
		},
	});
	$("form.validation [class*=validate]").on("change blur keyup", function () {
		$(this).validationEngine("validate");
	});

	$("body").on("click", "form.ajax button[type=submit]", function (e) {
		e.preventDefault();
		postFormAjax($(this).closest("form"));
		return false;
	});

	$("[data-mask]").each(function () {
		const type = $(this).data("mask");
		switch (type) {
			case "phone":
				$(this).inputmask({
					showMaskOnHover: false,
					mask: "(+abc*) ###-##-##",
					oncomplete: function () {
						const p = $(this).parent();
						if (!p.find("i.success").length)
							$("<i/>").addClass("success").appendTo(p);
						p.addClass("success");
					},
					onincomplete: function () {
						$(this).parent().removeClass("success");
					},
					definitions: {
						"a": {
							validator: "9",
							cardinality: 1,
							casing: "lower",
						},
						"b": {
							validator: "9",
							cardinality: 1,
							casing: "lower",
						},
						"c": {
							validator: "4",
							cardinality: 1,
							casing: "lower",
						},
						"#": {
							validator: "[0-9]",
							cardinality: 1,
							casing: "lower",
						},
						"*": {
							validator: "(10|50|51|55|60|70|77|99)",
							cardinality: 2,
							prevalidator: [{ validator: "[15679]", cardinality: 1 }],
						},
					},
				});
				break;
			case "numeric":
			case "integer":
				$(this).inputmask(type, { rightAlign: false });
				break;
			case "cur":
				$(this).inputmask({
					suffix: " " + $(this).data("currency"),
					groupSeparator: ",",
					alias: "numeric",
					placeholder: "0",
					autoGroup: !0,
					digits: 2,
					digitsOptional: !1,
					clearMaskOnLostFocus: !1,
					rightAlign: false,
				});
				break;
		}
	});

	$("select").select2({minimumResultsForSearch: Infinity});

	$("[data-match-height]").each(function () {
		$(this).find($(this).attr("data-match-height")).matchHeight();
	});

	if ($("[data-body-class]").length > 0) {
		$("body").addClass($("[data-body-class]:first").attr("data-body-class"));
	}

	$( ".training-block .item .img" ).each(function() {
		var attr = $(this).attr('data-image-src');
	  
		if (typeof attr !== typeof undefined && attr !== false) {
			$(this).css('-webkit-mask', 'url('+attr+')');
			$(this).css('mask', 'url('+attr+')');
		}
	  
	  });

	  if($('.smenu .slider').length>0){
		window.sMenu = tns({
			container: '.smenu .slider',
			items: 1.5,
			gutter: 0,
			edgePadding: 0,
			controls:false,
			nav:false,
			loop:false,
			responsive: {
				550: {
					items: 5,
				}
			},
			onInit:function () {
				const index = $('.smenu ul li').index($('.smenu ul li:has(a.active)'));
				setTimeout(()=>sMenu.goTo(index),10);
			}
		});
	}

	  if ($(".home-slider").length) {
		const homePartners = tns({
			container: ".home-slider .slider",
			items: 1,
			gutter: 0,
			edgePadding: 0,
			controlsText: ["", ""],
			nav: false,
			loop: true,
			controls: true,
			// "autoplay": true,
			// "autoplayTimeout": 3000,
			"autoplayText": ["",""],
			autoplayButtonOutput:false,
			responsive: {
				550: {
					items: 1,
				},
			},
		});
	}

	if ($(".gallery .slider").length) {
		tns({
			container: ".gallery .slider",
			items: 1,
			gutter: 30,
			controlsText: ["", ""],
			nav: false,
			loop: false,
			edgePadding: 30,
			mouseDrag: false,
			swipeAngle:false,
			responsive: {
				550: {
					items: 3,
					edgePadding: 0,
				},
			},
		});
	}

	if ($(".training-slider").length) {
		const homePartners = tns({
			container: ".training-slider .slider",
			items: 1,
			gutter: 0,
			edgePadding: 0,
			controlsText: ["", ""],
			nav: true,
			loop: true,
			controls: false,
			"autoplay": true,
			"autoplayTimeout": 3000,
			"autoplayText": ["",""],
			autoplayButtonOutput:false,
			responsive: {
				550: {
					items: 1,
				},
			},
		});
	}
	if($('.solutions .items .slider, .graduates .slider').length>0){
		const servicesSlider = tns({
			container: '.solutions .items .slider, .graduates .slider',
			edgePadding: 0,
			center:true,
			items: 1,
			gutter: 30,
			controls:false,
			nav:false,
			controlsText:["",""],
			loop:false,
			responsive: {
				550: {
					edgePadding:0,
					items: 3,
					center:false,
				}
			}
		});
	}

	if($('.others .news-list .slider').length>0){
		const servicesSlider = tns({
			container: '.others .news-list .slider',
			edgePadding: 15,
			center:true,
			items: 1.3,
			gutter: 30,
			controls:false,
			nav:false,
			controlsText:["",""],
			loop:false,
			responsive: {
				550: {
					edgePadding:15,
					items: 3,
					center:false,
				}
			}
		});
	}
	if ($(".members .slider").length) {
		const homePartners = tns({
			container: ".members .slider",
			items: 1.3,
			gutter: 30,
			edgePadding:0,
			controlsText: ["", ""],
			nav: false,
			loop: false,
			mouseDrag: true,
			controls: false,
			"autoplay": true,
			"autoplayTimeout": 3000,
			"autoplayText": ["",""],
			autoplayButtonOutput:false,
			responsive: {
				550: {
					items: 5,
				},
			},
		});
	}
	if($('.programs .detail-row .slider').length>0){
		const servicesSlider = tns({
			container: '.programs .detail-row .slider',
			edgePadding: 15,
			center:true,
			items: 1.3,
			gutter: 30,
			controls:false,
			nav:false,
			controlsText:["",""],
			loop:true,
			responsive: {
				550: {
					edgePadding:0,
					items: 4,
					center:false,
				}
			}
		});
	}
	
	// $('.owl-carousel').owlCarousel({
	// 	autoplay: false,
	// 	center: true,
	// 	loop: true,
	// 	nav: false,
	// 	items: 5,
	//   });
	// $('.slick-carousel').slick({
	// 	centerMode: true,
	// 	slidesToShow: 5,
	// 	dots: true,
	// 	autoplay: true,
	// 	autoplaySpeed: 3000,
	// 	pauseOnHover: true,
	// 	pauseOnDotsHover: true,
	// 	edgeFriction: 0.05,
	// 	infinite: true, 
	// 	  responsive: [
	// 	  {
	// 		breakpoint: 1024,
	// 		settings: {
	// 		  slidesToShow: 1
	// 		}
	// 	  }]
	//   });

	if($('.about-graph .items .slider').length>0){
		const servicesSlider = tns({
			container: '.about-graph .items .slider',
			edgePadding: 0,
			items: 1.5,
			gutter: 0,
			controls:false,
			nav:false,
			controlsText:["",""],
			loop:false,
			responsive: {
				550: {
					edgePadding:0,
					items: 4,
					center:false,
					controls:true
				}
			}
		});
	}

	if ($(".home-partners").length) {
		const homePartners = tns({
			container: ".home-partners .slider",
			items: 1.5,
			gutter: 32,
			edgePadding: 0,
			controlsText: ["", ""],
			nav: false,
			loop: true,
			controls: false,
			"autoplay": true,
			"autoplayTimeout": 3000,
			"autoplayText": ["",""],
			autoplayButtonOutput:false,
			responsive: {
				550: {
					items: 5,
					controls: true,
				},
			},
		});
	}
	if ($(".partners").length) {
		const homePartners = tns({
			container: ".partners .slider",
			items: 2,
			gutter: 32,
			edgePadding: 0,
			controlsText: ["", ""],
			nav: false,
			loop: true,
			controls: false,
			"autoplay": true,
			"autoplayTimeout": 3000,
			"autoplayText": ["",""],
			autoplayButtonOutput:false,
			responsive: {
				550: {
					items: 5,
				},
			},
		});
	}

	if ($(".experience").length) experience();

	if ($('.boss').hasClass('active')) {
		$("body").addClass('bg');
	  } else {
		$("body").removeClass('bg');
	  }

	$(window).scroll(function () {
		if ($(window).scrollTop() > 200) {
			$(".back-to-top").addClass("show");
		} else {
			$(".back-to-top").removeClass("show");
		}
	});
	$(".back-to-top").on("click", function (e) {
		e.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, "200");
	});

	const media = window.matchMedia("(max-width: 991px)");
	mobileSupport(media);
	media.addListener(mobileSupport);

	if($('.bg-home').length)$('body').addClass('home');
});

var momentSlider = $('.moments .owl-carousel');
	momentSlider.owlCarousel({
    autoplay: true,
	center: true,
	loop: true,
	nav: false,
	items: 3,
    responsive: {
	    0: {
	        items: 1
	    },
	    340: {
	        items: 1.5,
			margin: 20,
			center: true,
	    },
	    480: {
	        items: 1.5,
			margin: 20,
			center: true,
	    },
	    768: {
	        items: 1.5,
			margin: 20,
			center: true,
	    },
	    992: {
	        items: 3
	    },
	    1200: {
	        items: 3
	    }
    }
})

// function momentSliderClasses() {
//     momentSlider.each(function() {
//         var total = $(this).find('.owl-item.active').length;
//         $(this).find('.owl-item').removeClass('firstactiveitem');
//         $(this).find('.owl-item').removeClass('lastactiveitem');
//         $(this).find('.owl-item.active').each(function(index) {
//             if (index === 0) {
//                 $(this).addClass('firstactiveitem')
//             }
//             if (index === total - 1 && total > 1) {
//                 $(this).addClass('lastactiveitem')
//             }
//         })
//     })
// }
// momentSliderClasses();
// momentSlider.on('translated.owl.carousel', function(event) {
//    	momentSliderClasses()
// }); 

function experience() {
	const attrs = {},
		button = $(".experience .upload .select-file");
	$.each(button[0].attributes, function (index, attribute) {
		attrs[attribute.name] = attribute.value;
	});

	/* file uploader */
	$(".experience .upload")
		.fineUploader({
			//debug:true,
			uploaderType: "basic",
			autoUpload: false,
			multiple: false,
			button: button,
			request: {
				endpoint: attrs["data-url"],
				inputName: attrs["data-input-name"],
			},
			validation: {
				itemLimit: attrs["data-max-files"],
				allowedExtensions: ["pdf", "png", "jpg"],
				sizeLimit: 1024 * 1024 * attrs["data-size-limit"],
			},
			messages: {
				typeError: attrs["data-type-error"],
				sizeError: attrs["data-size-error"],
			},
		})
		.on("error", function (event, id, name, reason) {
			if (id === null) alertify.error(reason);
		})
		.on("complete", function (event, id, name, responseJSON) {
			if (responseJSON.code === 200) {
				$(".experience .success").removeClass("hide");
				$(".experience .file-preview,.experience .submit").addClass("hide");
			} else if (!!responseJSON.message) alertify.error(responseJSON.message);
		})
		.on("submit", function (elem, id, name) {
			button.addClass("hide");
			$(".experience .file-preview .name").html(name);
			$(".experience .file-preview").removeClass("hide");
			$(".experience .submit").removeClass("hide");
		});
	$("body").on("click", ".experience .file-preview .delete", function () {
		$(".experience .upload").fineUploader("reset");
		button.removeClass("hide");
		$(".experience .file-preview .name").html("");
		$(".experience .file-preview").addClass("hide");
		$(".experience .submit").addClass("hide");
	});
	$("body").on("click", ".experience .submit", function () {
		$(".experience .upload").fineUploader("uploadStoredFiles");
	});
}

window.unique_id = 0;
function uniqueId() {
	window.unique_id++;
	return "asgUniqueId_" + window.unique_id;
}
$.is_mobile = false;
const mobileSupport = (media) => {
	if (media.matches) {
		$.is_mobile = true;

		if (!$(".mobile-menu nav").length) {
			$("#header nav").clone().appendTo(".mobile-menu");
			$("#header .lang").clone().appendTo(".mobile-menu .header");
			$("#footer .social").clone().appendTo(".mobile-menu");
			$(".mobile-menu nav > ul > li:has(ul) a").click(function () {
				$(this).parent().toggleClass("active");
				$(".mobile-menu").toggleClass("nav_open");
			});
			$(".mobile-menu .close").click(function (e) {
				e.preventDefault();
				$(".mobile-menu nav li.active").removeClass("active");
				$(".mobile-menu").removeClass("nav_open active");
				setTimeout(() => $(".mobile-menu").removeClass("animate"), 400);
				$("body").removeClass("disable_scroll");
			});
			$(".open-mobile-menu").click(function () {
				$(".mobile-menu").toggleClass("animate");
				setTimeout(() => $(".mobile-menu").toggleClass("active"), 10);
				$("body").addClass("disable_scroll");
			});
		}

		if($('.tabs-header .slider').length>0){
			window.sMenu = tns({
				container: '.tabs-header .slider',
				items: 1.5,
				gutter: 30,
				edgePadding: 0,
				controls:false,
				nav:false,
				loop:false
			});
		}

		$(document).trigger("mobile_on");
	} else {
		$.is_mobile = false;

		$(document).trigger("mobile_off");
	}
};


function postFormAjax(form) {
	if (form.validationEngine("validate") && form.attr("request") != 1) {
		let url = form.attr("action");

		const disabled = [];

		form.find(":disabled").each(function () {
			disabled.push(this);
			$(this).prop("disabled", false).removeProp("disabled");
		});
		let data = form.serialize();

		$.each(disabled, function () {
			$(this).prop("disabled", true);
		});

		$.ajax({
			url: url,
			type: "POST",
			dataType: "json",
			cache: false,
			data: data,
			beforeSend: function () {
				form.attr("request", 1);
				if (
					form.css("position") != "absolute" &&
					form.css("position") != "relative"
				)
					form.css("position", "relative");
				$(
					'<div class="loading"><div class="lds-ripple"><div></div><div></div></div></div>'
				).appendTo(form);
			},
			success: function (data) {
				form.attr("request", 0);
				if (data.code == 200) {
					form.addClass("success");
					form.find('button[type="submit"]').prop("disabled", true);
				} else if (typeof data.message != "undefined") {
					alertify.error(data.message);
				}
			},
			error: function (x, e) {
				form.attr("request", 0);
				var e_msg = "";
				if (x.status == 0)
					e_msg = "You are offline!!<br> Please Check Your Network.";
				else if (x.status == 404) e_msg = "Requested URL not found.";
				else if (x.status == 500)
					e_msg = "Internel Server Error." + x.responseText;
				else if (e == "parsererror")
					e_msg = "Error.<br>Parsing JSON Request failed.";
				else if (e == "timeout") e_msg = "Request Time out.";
				else if (e == "error") e_msg = "Request error.";
				else if (e == "abort") e_msg = "Request abort.";
				else e_msg = "Unknow Error.<br>" + x.responseText;
			},
			complete: function () {
				$(".loading").remove();
			},
		});
	}
}
const accSingleTriggers = document.querySelectorAll('.accordion .title');

accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

function toggleAccordion() {
  const items = document.querySelectorAll('.accordion .item');
  const thisItem = this.parentNode;

  items.forEach(item => {
    if (thisItem == item) {
      thisItem.classList.toggle('is-open');
      return;
    }
    item.classList.remove('is-open');
  });
}
